import { calculateColumnWidth } from '@/roadmaps/helpers/roadmaps-column.helper';
/* eslint-disable no-restricted-imports */
/* eslint-disable internal-rules/no-store-in-composables */
import store from '@/vuex/store';
import { onMounted, ref, unref } from 'vue';

let columnBodyRef;
const columnWidth = ref(0);

export function getColumnWidth () {
    return unref(columnWidth);
}

export function observeColumnBodyResize (bodyRef) {
    columnBodyRef = bodyRef;

    const resizeObserver = new ResizeObserver((entries) => {
        columnWidth.value = calculateColumnWidth({
            columnCount: store.getters['roadmaps/columns/columnCount'],
            columnBodyWidth: entries[0].contentRect.width,
        });
    });

    onMounted(() => {
        resizeObserver.observe(columnBodyRef.value);
    });
}
